<template>
    <div class="o-newsletterGrid" :class="`o-newsletterGrid--${type}`">
        <div
            class="o-newsletterGrid__el"
            v-for="(el, idx) in list"
            :key="idx"
            :class="{
                big: type === 'grid' && idx === 0,
                medium: type === 'grid' && (idx === 1 || idx === 2),
                small:
                    (type === 'grid' && idx >= 3 && idx <= 5) || type !== 'grid'
            }"
        >
            <router-link :to="goToDetails(el.id)">
                <figure class="o-newsletterGrid__elFigure">
                    <img
                        v-if="el.graphicsLink"
                        class="img-fluid"
                        :src="el.graphicsLink"
                    />
                    <a-icon
                        v-else
                        class="o-newsletterGrid__elNoPhoto text-primary"
                        icon="NoPhoto"
                    />
                </figure>
                <div class="o-newsletterGrid__elContent">
                    <div class="d-flex justify-content-between flex-wrap mb-1">
                        <p class="o-newsletterGrid__elDate mb-0">
                            {{
                                $moment(
                                    el.publicationDate,
                                    'DD-MM-YYYY HH:mm'
                                ).format('DD-MM-YYYY, HH:mm')
                            }}
                        </p>
                        <div
                            v-if="showNewBadge && !el.read"
                            v-text="'Nowe'"
                            class="o-newsletterGrid__elBadge a-badge"
                        />
                    </div>
                    <h2 class="o-newsletterGrid__elTitle" v-text="el.title" />
                    <p
                        class="o-newsletterGrid__elDesc"
                        v-html="$options.filters.plainText(el.content)"
                    />
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsletterGrid',
    props: {
        list: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            default: 'grid'
        },
        showNewBadge: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToDetails(id) {
            return { name: 'newsletter-details', params: { id } }
        }
    }
}
</script>
